/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InspectionDataCategoryDto } from '../../models/inspection-data-category-dto';

export interface InspectionDataControllerFindAllCategories$Params {
}

export function inspectionDataControllerFindAllCategories(http: HttpClient, rootUrl: string, params?: InspectionDataControllerFindAllCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<InspectionDataCategoryDto>>> {
  const rb = new RequestBuilder(rootUrl, inspectionDataControllerFindAllCategories.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<InspectionDataCategoryDto>>;
    })
  );
}

inspectionDataControllerFindAllCategories.PATH = '/api/inspection-data/category';
